import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Segurnet';
  currentYear: number = 2025

  goFb:string='https://www.facebook.com/segurnetrd';
  goIg:string='https://www.instagram.com/segurnetrd';

  callUs:string='tel:+1-809-620-2524';
  cordenate:string='https://goo.gl/maps/Roi7AEStWadCJ5eX8';

  toggleBtn: string;

  @ViewChild('ToggleMenuMobile') btnMenu: ElementRef;
  @ViewChild('navResponsive') navRespo: ElementRef;

  // Go to top for routerlink change
  onActivate(event:Event) {
    window.scroll(0,0);
    this.toogleMenu();
  }
  //hide toggle menu
  toogleMenu() {
     this.btnMenu.nativeElement.attributes['aria-expanded'].value = false
     this.btnMenu.nativeElement.classList.remove("collapsed")
     this.navRespo.nativeElement.classList.remove("show")
  }

  //abrir fb
  fb(){
  window.open(this.goFb, "_blank");
 }

 //abrir ig
 ig(){
  window.open(this.goIg, "_blank");
 }

//abrir map
verMap(){
 window.open(this.cordenate, "_blank");
}

callUS(){
  console.log('Click')
  window.location.href ='tel:+1-809-620-2524';
}

ngOnInit(): void {
  this.currentYear = new Date().getFullYear();
}

}
